import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { driverApi } from "@/lib/entities";
import { useAuth } from "@/contexts/AuthContext";
import { PageHeader, PageShell } from "@/components/PageHeader";
import { CredentialChip } from "@/components/Chips";

export default function MyDriverProfile() {
  const { user } = useAuth();
  const [driver, setDriver] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    driverApi.me().then(setDriver).catch((e) => setErr(e));
  }, []);

  if (err) {
    return (
      <PageShell>
        <PageHeader title="My Driver Profile" subtitle={user?.email} testid="page-my-driver" />
        <div data-testid="my-driver-empty" className="bg-white border border-coach-silver rounded-md p-8 text-[13px] text-steel">
          No driver record is linked to your user account yet. Please contact dispatch.
        </div>
      </PageShell>
    );
  }
  if (!driver) {
    return (
      <PageShell>
        <div className="text-steel text-sm">Loading…</div>
      </PageShell>
    );
  }

  return (
    <PageShell>
      <PageHeader
        testid="page-my-driver"
        title={driver.display_name}
        subtitle={
          <span className="font-mono text-steel text-[12px]">{driver.driver_number}</span>
        }
      />
      <div className="bg-white border border-coach-silver rounded-md p-4 grid md:grid-cols-3 gap-4">
        <ComplianceItem label="CDL" exp={driver.cdl_expiration} level={driver.credential_status?.cdl} />
        <ComplianceItem label="Medical Card" exp={driver.medical_card_expiration} level={driver.credential_status?.medical_card} />
        <ComplianceItem label="Passport" exp={driver.passport_expiration} level={driver.credential_status?.passport} />
      </div>
    </PageShell>
  );
}

const ComplianceItem = ({ label, exp, level }) => (
  <div className="p-3 bg-road-white border border-coach-silver rounded-sm">
    <div className="text-[10.5px] uppercase tracking-widest text-steel">{label}</div>
    <div className="mt-1"><CredentialChip level={level || "unknown"} label={exp || "—"} /></div>
  </div>
);
